export default __webpack_public_path__ + "static/media/beta.8c8a67c6.jpg";